import { render, staticRenderFns } from "./results.vue?vue&type=template&id=16bd3054"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=16bd3054&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/farescraper.com/components/AppHeader.vue').default,HomeHero: require('/home/forge/farescraper.com/components/HomeHero.vue').default,FlightsFiltersSkeleton: require('/home/forge/farescraper.com/components/FlightsFiltersSkeleton.vue').default,FlightsFilters: require('/home/forge/farescraper.com/components/FlightsFilters.vue').default,FlightsFiltersOptionsSkeleton: require('/home/forge/farescraper.com/components/FlightsFiltersOptionsSkeleton.vue').default,FlightsFiltersOptions: require('/home/forge/farescraper.com/components/FlightsFiltersOptions.vue').default,FlightsListSkeleton: require('/home/forge/farescraper.com/components/FlightsListSkeleton.vue').default,FlightsList: require('/home/forge/farescraper.com/components/FlightsList.vue').default,GoogleAdSense: require('/home/forge/farescraper.com/components/GoogleAdSense.vue').default,ModalCompare: require('/home/forge/farescraper.com/components/ModalCompare.vue').default,AppFooter: require('/home/forge/farescraper.com/components/AppFooter.vue').default,AppMobileFooter: require('/home/forge/farescraper.com/components/AppMobileFooter.vue').default,DebugBar: require('/home/forge/farescraper.com/components/DebugBar.vue').default})
